<template>
  <v-popover-actions placement="bottom-end" class="presentation-download">
    <slot :loading="loading">
      <v-button :compressed="compressed" :primary="primary" :disabled="loading" class="presentation-download__trigger">
        <span class="presentation-download__spinner" />
        {{ label }}
      </v-button>
    </slot>
    <template #actions="{ onClick }">
      <v-button-wide @click="onClick(() => openPreview(false))">
        Классическая
      </v-button-wide>
      <v-button-wide @click="onClick(() => openPreview(true))">
        Мобильная
      </v-button-wide>
    </template>
  </v-popover-actions>
</template>

<script>
import VPopoverActions from '@/components/common/VPopoverActions.vue'
import VButtonWide from '@/components/common/VButtonWide.vue'
import VButton from '@/components/common/VButton.vue'
import { getPresentationPreviewUrl } from '@/services/presentation'

export default {
  name: 'PresentationDownload',
  components: { VPopoverActions, VButtonWide, VButton },
  props: {
    entityType: { type: String, required: true },
    entityId: { type: [Number, String], required: true },
    label: { type: String, default: 'PDF' },
    compressed: { type: Boolean, default: false },
    primary: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    openPreview(mobile) {
      const url = getPresentationPreviewUrl({
        entityType: this.entityType,
        entityId: this.entityId,
        mobile
      })
      window.open(url, '_blank')
    }
  }
}
</script>
